import styled from '@emotion/styled';

interface IContainerProps {
    backgroundColor: string;
}

interface ITextProps {
    color: string;
}

export const StyledLabelContainer = styled.span<IContainerProps>`
    height: 25px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    background-color: ${(containerProps) => containerProps.backgroundColor};

    svg {
        width: 25px;
        height: 25px;
        margin-left: -10px;
        margin-right: 5px;
        padding: 5px;

        path {
            fill: ${(props) => props.theme.shades.white};
        }
    }
`;

export const StyledLabelText = styled.span<ITextProps>`
    font-size: ${(props) => props.theme.fontSize.copyTextS};
    color: ${(props) => props.color};
    font-weight: 600;
    display: flex;
    align-items: center;
`;
